import { gsap } from 'gsap/all'
import { store } from '../../src/js/core/store.js'

export class BlockLinks {
  constructor () {
    this.blockLinks = [...document.querySelectorAll('.js-block-link')]
    if (this.blockLinks.length <= 0) { return false }


    if (!store.isDevice) {
      this.blockLinks.forEach(link => {
        new BlockLink(link)
      })
    }
  }
}

class BlockLink {
  constructor (element) {
    this.blockLink = element
    this.text = this.blockLink.querySelectorAll('.js-text')
    this.mouseover = false

    this.init()
  }

  init = () => {
    this.addBackground()
    this.setDefaults()
    this.createTimelines()
    this.bindEvents()
  }

  addBackground = () => {
    this.background = document.createElement('div')
    this.background.className = 'block_links__block__background'
    this.background.style.position = 'absolute'
    this.background.style.top = 0
    this.background.style.right = 0
    this.background.style.bottom = 0
    this.background.style.left = 0

    this.blockLink.appendChild(this.background)
  }

  setDefaults = () => {
    gsap.set(this.background, { y: '100%' })
  }

  createTimelines = () => {
    this.createTimelineEnter()
    this.createTimelineLeave()
  }

  createTimelineEnter = () => {
    this.timelineEnter = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false

        if (!this.mouseover) {
          this.timelineLeave.restart()
        }
      }
    })

    this.timelineEnter
      .to(this.text, 0.25, { y: -6, opacity: 0, ease: 'power2.in' }, 'a')
      .set(this.text, { y: 6, color: '#fff' })
      .to(this.text, 0.25, { y: 0, opacity: 1, ease: 'power2.out' })
      .to(this.background, 0.5, { y: 0, ease: 'power2.inOut' }, 'a')
  }

  createTimelineLeave = () => {
    this.timelineLeave = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false

        if (this.mouseover) {
          this.timelineEnter.restart()
        }
      }
    })

    this.timelineLeave
      .to(this.text, 0.25, { y: -6, opacity: 0, ease: 'power2.in' }, 'a')
      .set(this.text, { y: 6, color: '' })
      .to(this.text, 0.25, { y: 0, opacity: 1, ease: 'power2.out' })
      .to(this.background, 0.5, { y: '-100%', ease: 'power2.inOut' }, 'a')
  }

  bindEvents = () => {
    this.blockLink.addEventListener('mouseenter', this.handleEnter)
    this.blockLink.addEventListener('mouseleave', this.handleLeave)
  }

  handleEnter = () => {
    this.mouseover = true

    if (!this.timelinePlaying) {
      this.timelineEnter.restart()
    }
  }

  handleLeave = () => {
    this.mouseover = false

    if (!this.timelinePlaying) {
      this.timelineLeave.restart()
    }
  }
}
